
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { config } from '../../../config'

export const dailyReportApi = createApi({
    reducerPath: 'dailyReportApi',
    baseQuery: fetchBaseQuery({
        baseUrl: config().BASE_URL,
        prepareHeaders: (headers) => {
            headers.set("Authorization", `Token ${localStorage.getItem('cw-token')}`)
            return headers
        }
    }),
    tagTypes: ['dailyReport'],
    endpoints: (builder) => ({
        createDailyReport: builder.mutation<any, Partial<any>>({
            query: (body) => ({
                url: '/create-daily-report',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['dailyReport']
        }),
        getDailyReports: builder.query<any, void>({
            query: () => ({
                url: '/get-daily-reports',
                method: 'GET',
            }),
            providesTags: ['dailyReport']
        }),
    })
})

export const { useCreateDailyReportMutation, useGetDailyReportsQuery } = dailyReportApi
